module.exports = __webpack_public_path__ + "shenhewuxiao.png?a3bf6c3072576962129216b08b10a45c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shenhewuxiao.png
// module id = 76
// module chunks = 0